import styled from 'styled-components';

import {grey} from '@drivesally/sally-ui/lib/libs/colors';

const TeamsHeader = styled.div`
  align-items: center;
  border-bottom: 1px solid ${grey};
  display: flex;
  flex-shrink: 0;
  height: 53px;
  padding: 0 20px;
`;

export default TeamsHeader;
